import React from 'react';

export const TherapiesSitesLogo = () => (
  <svg viewBox="0 0 471 57" fill="none" xmlns="http://www.w3.org/2000/svg" color="black" width="152" height="18">
    <path
      d="M85.96 38.3523V47.3623H52.77V9.26231H85.64V18.2223H63.78V23.4523H83.96V32.6323H63.78V38.3523H85.96Z"
      fill="black"
    />
    <path
      d="M144.46 9.26231V47.3623H133.56V26.9623L125.73 47.3623H113.59L105.76 26.9623V47.3623H94.86V9.26231H109.6L119.69 35.0023L129.78 9.26231H144.46Z"
      fill="black"
    />
    <path
      d="M172.52 18.2223H164.75V26.7523H172.63C176.08 26.7523 177.54 25.6723 177.54 22.4923C177.54 19.3123 175.97 18.2323 172.52 18.2323V18.2223ZM172.3 35.7623H164.74V47.3623H153.73V9.26231H172.35C182.93 9.26231 188.76 13.9023 188.76 22.4823C188.76 31.0623 182.88 35.7623 172.3 35.7623Z"
      fill="black"
    />
    <path
      d="M195.94 9.26231H206.95V31.0623C206.95 33.1623 207.6 35.0023 208.84 36.6223C210.08 38.2423 212.24 39.0523 215.21 39.0523C218.18 39.0523 220.39 38.2423 221.63 36.6223C222.87 35.0023 223.52 33.1723 223.52 31.0623V9.26231H234.53V30.2523C234.53 36.4023 232.75 40.9423 229.19 43.8523C225.68 46.7623 220.99 48.2223 215.21 48.2223C209.43 48.2223 204.74 46.7623 201.23 43.8523C197.72 40.9423 195.94 36.4023 195.94 30.2523V9.26231Z"
      fill="black"
    />
    <path
      d="M244.4 35.9223C246.07 36.7323 248.12 37.4923 250.61 38.1323C253.15 38.7223 255.52 39.0523 257.79 39.0523C262.16 39.0523 264.32 38.3523 264.32 36.9523C264.32 35.3823 262 34.6323 257.73 33.7723C257.14 33.7223 256.49 33.5523 255.68 33.3423C246.72 31.2923 241.7 28.8123 241.54 20.4923C241.54 16.4423 243.16 13.4223 246.45 11.4223C249.74 9.42231 254.01 8.40231 259.24 8.40231C264.47 8.40231 270.79 9.75231 275.16 12.0723L271.65 20.1123C267.71 18.5423 262.64 17.6323 258.97 17.6323C254.92 17.6323 252.66 18.4923 252.66 20.0123C252.66 21.5323 254.82 22.2223 258.76 22.9223L260.33 23.2423C265.13 24.2723 268.86 25.6723 271.5 27.5623C274.14 29.4023 275.49 32.1523 275.49 35.8223C275.49 39.9823 273.82 43.1123 270.47 45.1623C267.13 47.2123 262.75 48.2423 257.36 48.2423C254.45 48.2423 251.48 47.8623 248.45 47.0523C245.43 46.2423 242.84 45.2123 240.73 43.9223L244.4 35.9323V35.9223Z"
      fill="black"
    />
    <path d="M0 18.1623H4.87V9.26231H0V18.1623Z" fill="black" />
    <path d="M7.46 18.1623H16.36V9.26231H7.46V18.1623Z" fill="black" />
    <path d="M20.04 47.3623H31.05V18.1623H37.36V9.26231H20.04V47.3623Z" fill="black" />
    <path d="M39.95 9.26231V18.1623H43.62V9.26231H39.95Z" fill="black" />
    <path d="M301.152 56.4318H305.418V0.433838H301.152V56.4318Z" fill="black" />
    <path d="M338.678 41.3658V9.23584H331.982V47.3598H358.172V41.3658H338.678Z" fill="black" />
    <path d="M370.986 47.3598H377.681V9.23584H370.986V47.3598Z" fill="black" />
    <path
      d="M418.651 9.23584V37.2078L399.697 9.23584H392.893V47.3598H399.427V19.2258L418.489 47.3598H425.185V9.23584H418.651Z"
      fill="black"
    />
    <path
      d="M462.364 47.3598H470.518L456.1 25.3818L469.762 9.23584H461.338L446.758 27.9738V9.23584H440.116V47.3598H446.758V36.3978L451.564 30.0258L462.364 47.3598Z"
      fill="black"
    />
  </svg>
);
